export type CoreDrawerMode =
    | 'over'
    | 'side';

export type CoreDrawerPosition =
    | 'left'
    | 'right';
